import { useEffect } from 'react';
import { X, Shield } from 'lucide-react';
import { SavChatBlock } from './SavChatBlock';

interface SavGarantMessageModalProps {
  isOpen: boolean;
  onClose: () => void;
  savId: number;
}

export function SavGarantMessageModal({ isOpen, onClose, savId }: SavGarantMessageModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-transition-opacity"
        style={{ zIndex: 50 }}
        onClick={onClose}
      />

      <div className="tw-fixed tw-inset-0 tw-overflow-y-auto" style={{ zIndex: 50 }}>
        <div className="tw-flex tw-min-h-full tw-items-center tw-justify-center tw-p-4">
          <div
            className="tw-relative tw-w-full tw-max-w-2xl tw-bg-white tw-rounded-lg tw-shadow-xl tw-flex tw-flex-col tw-max-h-[85vh]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="tw-flex tw-items-center tw-justify-between tw-px-6 tw-py-4 tw-border-b tw-border-gray-200 tw-flex-shrink-0">
              <div className="tw-flex tw-items-center tw-gap-3">
                <div className="tw-flex-shrink-0 tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-bg-affinicar-lighter">
                  <Shield className="tw-w-5 tw-h-5 tw-text-affinicar-primary" />
                </div>
                <h3 className="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-0">
                  Messagerie garant
                </h3>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="tw-text-gray-400 hover:tw-text-gray-600 tw-transition-colors"
                aria-label="Fermer"
              >
                <X className="tw-w-5 tw-h-5" />
              </button>
            </div>

            {/* Chat */}
            <div className="tw-flex-1 tw-min-h-0 tw-overflow-hidden">
              <SavChatBlock savId={savId} channel="garant" title="Messagerie garant" icon={Shield} readOnly={false} defaultShowInput />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
